// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-menu ul {\n  padding: 0px;\n  margin: 0px;\n}\n.base-menu ul li a[disabled] {\n    pointer-events: none;\n    cursor: not-allowed;\n    color: #B2B2B2;\n}\n.base-menu ul li span.label {\n    display: block;\n    width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
